import { type ILanguageKeys } from './interface'

export const esMx: ILanguageKeys = {
  threeMonths: '3 meses',
  sixMonths: '6 meses',
  tenMonths: '10 meses',
  oneYear: '1 año',
  accessoriesSuppliesAndTools: 'Accesorios, suministros y herramientas',
  account: 'Cuenta',
  actions: 'Comportamiento', //TODO
  add: 'Añadir',
  ADD: 'Añadir',
  addA: 'Añadir a',
  addACustomName: 'Añadir un nombre personalizado',
  addAllToCart: 'Añadir todo a la cesta',
  addAtLeastOneItemToList: 'Añade al menos un artículo a la lista', // TODO
  addItems: 'Añadir artículos',
  addItemsToGroup: 'Añadir artículos al Grupo',
  additionalDetails: 'Detalles adicionales',
  additionalFitmentInformationIsNeededBeforeResultsCanBeDisplayed:
    'Se necesita información adicional de compatibilidad antes de poder mostrar los resultados',
  additionalOptions: 'Opciones adicionales',
  additionalOrderOptions: 'Opciones de pedido adicionales',
  addJust: 'Añadir sólo',
  addManually: 'AÑADIR MANUALMENTE',
  addNewList: 'Añadir nueva lista',
  addNewRow: 'Añadir nueva fila',
  addParts: 'Añadir piezas',
  addPartToList: 'Añadir pieza a listas',
  additionalQuoteOptions: 'Opciones de cotización adicionales',
  addQuoteToCart: 'Añadir cotización a la cesta',
  updateAndAddToCart: 'Actualizar y añadir al carrito', //TO DO
  addThenBy: `"Luego por"`,
  unSelectAll: 'deseleccionar todo',
  addToCart: 'Añadir a la cesta',
  addToList: 'Añadir a lista',
  addVehicle: 'Añadir vehículo',
  adhesives: 'Adhesivos',
  advancedSearch: 'Búsqueda Avanzada',

  aftermarketPartAvailable: 'Recambios disponibles',
  all: 'Todos',
  all31Days: 'Todos (31 días)',
  allCarts: 'todos los carros',
  allEngines: 'Todos los motores',
  allItemsFromEachCartWillBeRemovedAndCannotBeUndone:
    'Todos los artículos de cada carro se eliminarán y no se podrán deshacer.',
  allItemsFromThisOrderHaveBeenReturned:
    'Todos los artículos de este pedido han sido devueltos.',
  allianceConnect: 'Alliance Connect',
  allLines: 'Todas las líneas',
  allOrders: 'Todos los pedidos',
  allParts: 'Todas las piezas',
  allProducts: 'Todos Los Productos',
  allRightsReserved: 'Todos Los Derechos Reservados',
  allVehicles: 'Todos los vehículos',
  allVehiclesWereSavedAsQuotes:
    'Todos los vehículos guardados como cotizaciones',
  alternateFor: 'Alternar por',
  amount: 'cantidad',
  available: 'Disponible',
  amountRequestedCanBeOrderedButWillTakeLongerToBeDelivered:
    'La cantidad solicitada puede pedirse pero tardará más tiempo en ser entregada',
  amountRequestedUnavailableItCanBeOrderedFromOtherLocation:
    'Cantidad solicitada no disponible. Se puede pedir desde otra ubicación.',
  amountRequestedUnavailableAndCanBeOrderedFromOtherLocation:
    'Cantidad solicitada no disponible en %, puede estar disponible en otras ubicaciones.', // TODO
  anAdminWillBeReachingOutToYou:
    'Un administrador se pondrá en contacto contigo. Si no recibe respuesta, póngase en contacto con el servicio de atención al cliente.',
  apply: 'Aplicar',
  applySort: 'Aplicar clasificación', // TODO
  applyChanges: 'Aplicar cambios',
  areNotAvailableInOurDatabase:
    'no están disponibles en nuestra base de datos.',
  areYouSureYouWantTo: '¿Está seguro de que desea',
  areYouSureYouWantToCancelReturnRquest:
    '¿Está seguro de que desea cancelar la solicitud de devolución?',
  areYouSureYouWantToDelete: '¿Seguro que desea eliminar?',
  areYouSureYouWantToEmptyYour: '¿Está seguro de que quieres vaciar tu',
  areYouSureYouWantToEmptyYourCart: '¿Está seguro que desea vaciar su cesta?',
  areYouSureYouWantToRemove: '¿Está seguro que quiere eliminar',
  areYouSureYouWantToRemoveTheReturnRequest:
    '¿Está seguro de que desea eliminar el % de esta solicitud de devolución?',
  areYouSureYouWantToRemoveYour: '¿Está seguro que desea eliminar su',
  areYouSureYouWantToUpdate: '¿Está seguro que desea actualizar',
  arrivedLate: 'Llegó tarde',
  arrivedOn: 'llegó el %',
  at: 'en',
  atOtherLocations: '% en otros lugares',
  automaticEntry: 'entrada automática.',
  automaticEntryYouHave: 'entrada automática. Usted tiene ',
  availability: 'Disponibilidad',
  aVehicleWasNotFound:
    'No se ha encontrado ningún vehículo. Por favor, seleccione el vehículo manualmente.',
  awaitingShipment: 'En espera de envío',
  back: 'Volver',
  backToAllDiagrams: 'Volver a todos los diagramas',
  backToCart: 'Volver a la cesta',
  backToLogin: 'Volver al inicio de sesión',
  backToOrders: 'Volver a Historial de pedidos',
  backToOrderDetails: 'Volver a Detalles del pedido',
  backToInvoice: 'Volver a los detalles de la factura', //TO DO
  backToPartType: 'Volver al tipo de pieza',
  backToPreviousPage: 'Volver a la página anterior',
  backToSearchResults: 'Volver a los resultados de la búsqueda', //TODO - review
  backToReturnSelection: 'Volver a la selección de retorno',
  backToReviewItems: 'Volver a Revisar artículos',
  backToSavedQuotes: 'Volver a Cotizaciones guardadas',
  backToVehicleDetails: 'Volver a los detalles del vehículo', // TODO
  backToTop: 'Volver al inicio',
  belowIsAListOfAllOE:
    'A continuación se muestra una lista de todas las piezas EO y del mercado de accesorios, incluidos los artículos que no se venden en nuestros almacenes. Esta herramienta es sólo para referencia.',
  bestEmailToReachYouAt:
    'Mejor correo electrónico para comunicarse con usted en',
  brand: 'Marca',
  brandAZ: 'Marca (A-Z)',
  brandZA: 'Marca (Z-A)',
  Brands: 'Marcas',
  browseFile: 'Examinar archivo',
  buyAgain: 'Comprar otra vez',
  bundled: 'Incluida',
  callForAvailability: 'Llamar para disponibilidad',
  callForPrice: 'Llamar para precio',
  cancel: 'Cancelar',
  cancelReturnRequest: 'Cancelar solicitud de devolución',
  cannotDeleteCategory: 'La categoría no puede ser eliminada',
  cart: 'Carrito',
  cartId: 'ID del carrito',
  cartID: 'ID del carrito',
  cartOnlyHasLaborInIt: '% de carros con mano de obra',
  cartsOnlyHaveLaborInThem: '% de carros con mano de obra',
  cartTotal: 'Total de carros',
  cat: 'Cat',
  catalogDiagram: 'Catálogo Diagrama',
  categories: 'Categorías',
  category: 'Categoría',
  categoryDeletionError: 'Error de eliminación de categoría',
  categoryNameAlreadyExists: 'El nombre de la categoría ya existe',
  categoryNameExceedsChars:
    'El nombre de la categoría supera los 30 caracteres',
  change: 'cambiar',
  changedStoreDueToAvailability:
    'Cambio de tienda debido a la disponibilidad del artículo',
  changeGraphic: 'Modificar gráfico',
  changeLoaction: 'Cambiar acción',
  changeLocation: 'Cambiar ubicación',
  changeVehicle: 'Cambiar vehículo',
  chemicals: 'Productos químicos',
  choosePartType: 'Elija el tipo de pieza',
  choosePartTypeDescription: `Optimizar mi búsqueda de intercambio mostrando primero todos los tipos de
piezas que corresponden al número de pieza especificado antes de mostrar mis
resultados`,
  chooseVehicleSystem: 'Elegir sistema de vehículo',
  clear: 'clara',
  clearAll: 'Borrar todo',
  clearAllFilters: 'Borrar todos los filtros',
  clearFilters: 'Borrar filtros',
  clearSearch: 'Borrar búsqueda',
  clearSelections: 'Borrar selecciones',
  click: 'Haga clic en',
  clickButtonBelowToBeginAddingItemsToThisGroup:
    'Haga clic en el botón a continuación para comenzar a agregar elementos a este grupo',
  clickingThisPartWillChangeGraphic:
    'Al hacer clic en esta parte cambiará el gráfico que se muestra actualmente',
  clickPartToSelectAndHighlight:
    'Haga clic en la pieza para seleccionarla y resaltarla en la lista siguiente',
  clickToViewAvailableMfgList:
    'Haga clic para ver la lista de fabricantes disponibles',
  clickToViewPrintPartNumbers:
    'Haga clic para ver/imprimir los números de pieza',
  close: 'Cerrar',
  closeGroups: 'Cerrar Grupos',
  code: 'Código',
  commentOptional: 'Comentario (Opcional)',
  comments: 'Comentarios',
  confirm: 'Confirmar', // TODO
  confirmOrder: 'Confirmar pedido', // TODO
  confirmation: 'Confirmación #',
  confirmRequest: 'CONFIRMAR SOLICITUD',
  confirmationId: 'Confirmación Id',
  confirmationID: 'ID de confirmación',
  confirmNewPassword: 'Confirmar nueva contraseña',
  congratulationsThisOrderHasQualifiedFor:
    '¡Felicidades! Este pedido se ha clasificado para',
  congratulationsThisOrderQualifiesFor:
    '¡Felicidades! Este pedido clasifica para',
  contactAdminToRequestPasswordReset:
    'Comuníquese con el administrador para solicitar el restablecimiento de la contraseña',
  contactSellerDirectlyForDeliveryUpdates:
    'Póngase en contacto directamente con el vendedor para obtener actualizaciones de entrega.',
  contactUs: 'Contáctenos',
  continueRquest: 'Continuar Solicitud',
  copiedToClipboard: 'Copiada al portapapeles', //TODO
  copypart: 'Copiar pieza',
  copyLineCodeFromPreviousRow: 'Copiar código de línea de la fila anterior',
  core: 'Básico',
  coreCost: 'Costo básico',
  coreFee: 'Cuota básica',
  coreList: 'Lista básica',
  coreOnly: 'Solo núcleo',
  corePrice: 'Precios básicos',
  copyToAllCarts: 'Copiar a todos los carritos',
  cost: 'Costo',
  condensed: 'Condensado',
  costBreakdown: 'Desglose de costos',
  costChangedFrom: 'El costo ha cambiado de % a %', //TODO
  costDetails: 'Detalle de costos',
  costHighLow: 'Costo (Alto-Bajo)',
  costLowHigh: 'Costo (Bajo-Alto)',
  costSummary: 'Resumen de costos',
  courier: 'Mensajería',
  createCategory: 'Crear Categoría',
  createdDate: 'Fecha de creación',
  createdOn: 'Creado el',
  crossReferenceResults: 'Resultados de Referencias Cruzadas',
  createGroup: 'Crear Grupo',
  createList: 'Crear lista',
  crossReference: 'Referencia cruzada', // TODO review
  crossReferenceTool: 'herramienta de referencias cruzadas', // TODO review
  crossReferenceToolNoResults: 'HERRAMIENTA DE REFERENCIAS CRUZADAS',
  crossReferenceTooltipMsg:
    'Use nuestra herramienta de referencia cruzada para obtener una lista completa de todas las partes intercambiables por:  %', // TODO review
  current: 'Actual',
  customize: 'Personalizar',
  customMakes: 'Marcas personalizadas',
  customizeMakeList: 'Personalizar la lista de marcas',
  selectTheCartYouWantToAddItemsTo:
    'Selecciona el carrito al que deseas agregar los artículos',
  selectTheMakesThatYouWantToSeeWhenAddingAVehicle:
    'Seleccione las marcas que desea ver al agregar un vehículo',
  customerName: 'Nombre del cliente',
  cancelAddingItems: 'Cancelar añadir artículos', // TODO
  continueWorking: 'Continuar trabajando', // TODO
  areYouSureYouWantToCancelYourItemsWillNotBeAdded:
    '¿Está seguro de que desea cancelar? Sus artículos no se añadirán a', // TODO
  customizeSearchPreferences: 'Personalizar las preferencias de búsqueda',
  customizeSearch: 'Personalizar búsqueda',
  customName: 'Nombre personalizado',
  clearVehicle: 'vehículo limpio', // TODO
  cscOnly: 'Solo CSC',
  damagedPartInbox: 'Bandeja de entrada de piezas dañadas',
  dashboard: 'panel', //TODO
  date: 'Fecha',
  dateAdded: 'Fecha de adición', // TODO
  dateRange: 'Intervalo de fechas',
  dateRequested: 'Fecha solicitada',
  delayedDeliveryDisclaimer:
    'No tenemos suficiente cantidad de este artículo disponible en la ubicación seleccionada. Trabajaremos para completar este pedido, pero la entrega puede retrasarse.',
  delete: 'Borrar',
  default: 'por defecto',
  defaultVehicleType: 'Tipo de vehículo predeterminado  ',
  defaultSetting: 'Predeterminado',
  defective: 'Defectuosa',
  deleteCategory: 'Borrar categoría',
  deleteFromGroup: 'Eliminar del grupo', // TODO
  deleteGroup: 'Borrar grupo',
  deleteItemFromList: 'Eliminar elementos de listas',
  deleteItems: 'Eliminar elementos',
  deleteList: 'Borrar lista',
  deleteMessage: '¿Está seguro que desea eliminar',
  deleteQuote: 'Borrar cotización',
  deleteQuotes: 'Borrar cotizaciones',
  deleteQuotesOlderThan: 'Borrar cotizaciones anteriores a',
  deleteVehicle: 'Borrar vehículo',
  delivered: 'Entregado',
  deliveryMayBeDelayed: 'La entrega puede retrasarse',
  deliveryStatus: 'Estado de la entrega',
  deliveryStatusUnavailable: 'Estado de entrega no disponible', // TODO
  deliveryStatusUnavailableOrderPlacedByOtherMeans:
    'Estado de entrega no disponible. Este pedido se realizó por teléfono, en persona o a través de otra aplicación.', // TODO
  description: 'Descripción',
  descriptionAZ: 'Descripción (A-Z)', //TODO
  descriptionZA: 'Descripción (Z-A)', //TODO
  descriptions: 'Descripciones',
  desktop: 'Escritorio',
  details: 'Detalles',
  diagram: 'Diagrama',
  diagrams: 'Diagramas',
  didYouMeanToSearchFor: 'Te refieres a buscar por',
  dismiss: 'Descartar',
  dispatchAndDelivery: 'Envío y entrega',
  dispatchNotificationNotFound: 'Notificación de envío no encontrada', // TODO
  dontAskPartTypeAgain: `No volver a preguntar "Tipo de pieza"`,
  dontAskManufacturerAgain: `No volver a preguntar "Del fabricante"`,
  dontShowThisAgain: `No vuelvas a mostrar esto`,
  doingSoWillRemoveAllItems: 'Al hacerlo, se eliminarán todos los elementos.',
  dragAndDrop: 'o arrástrelo y suéltelo aquí',
  dragAndRearrangeTheItemsInThisListToArrangeThemInYourPreferredDisplayOrder:
    'Arrastre los elementos de esta lista para colocarlos en el orden de su preferencia',
  duplicateVehicle: 'Duplicar vehículo',
  eachAndEveryPerfectStopProductPurchaseearnsanenrty:
    'Todas y cada una de las compras de productos % recibe una entrada',
  eachQualifyingInvoiceTotalEarnsYouAnEntry:
    'Gane una entrada por cada factura que califique de $150.00 o más.  Los usuarios de MyPlace4Parts ahora obtienen entradas adicionales por cada incremento diario de $150',
  edit: 'Editar',
  editCustomName: 'Editar nombre personalizado',
  editFitmentConditions: 'Editar condiciones de montaje',
  editItem: 'Editar Artículo',
  editList: 'Editar Lista',
  editParts: 'Editar Piezas',
  editSearch: 'Editar búsqueda',
  editUnknownItem: 'Editar artículo desconocido',
  editVehicle: 'Editar vehículo',
  email: 'Correo electrónico',
  emailAddress: 'Dirección de correo electrónico',
  emailRequired: 'Correo electrónico requerido',
  emptyCart: 'Carrito vacío',
  endUserLicenseAgreement: 'Acuerdo de licencia de usuario final', // TODO
  engine: 'Motor',
  english: 'Inglés',
  enterAPlateNumber: 'Introduzca un número de matrícula',
  enterCode: 'Introducir código',
  enterNewPassword: 'Introducir nueva contraseña',
  enterPart: 'Introduzca el número de pieza para intercambiar o buscar',
  enterVehicle: 'Ingresar vehículo', // TODO
  enterVin: 'Introduzca VIN',
  entryAddjust: 'entrada(s). Añadir sólo ',
  entryToDate: 'entrada(s) hasta la fecha.',
  entryYouHaveReachedTheMaximumNumberOfEntriesYouHave:
    'entrada(s). Ha alcanzado el número máximo de entradas. Ha ocurrido ',
  error: 'Error', // TODO
  errorAddingProductsToTheCart: 'Error al añadir productos al carrito',
  errorDeletingVehicle: 'Error al borrar un vehículo',
  errorLoadingBannerPromotion: 'Error al cargar banner de promoción',
  errorLoadingEntries: 'Error al cargar entradas',
  errorMovingList: 'Error al mover la lista',
  errorOccurredWhileUpdatingVehicleName:
    'Se ha producido un error al actualizar el nombre del vehículo',
  errorProcessingOrders: 'Error al procesar pedidos',
  errorUpdatingProductQuantity: 'Error al actualizar la cantidad de productos',
  errorValidatingList: 'Se ha producido un error al validar la lista.',
  deliverBy: 'Entrega antes de las',
  estimatedDelivery: 'Entrega estimada',
  exactMatch: 'Coincidencia exacta',
  existingCartWarningModal:
    'Usted tiene un vehículo existente en su carro que coincide con estas especificaciones. ¿Desea iniciar un nuevo carro o fusionarlo con el carro % existente?',
  expandAll: 'Expandir todo',
  experianAutocheck: 'Autocomprobación de Experian',
  explanation: 'Explicación',
  exportList: 'Exportar lista',
  extraDetails: 'Detalles adicionales', // TODO
  favorites: 'Favoritos',
  failedToAddPartsToGroup: 'No se han podido añadir las piezas al grupo', // TODO
  failedToImportTheList: 'No se ha podido importar la lista', // TODO
  failedToLogin: 'Error al iniciar sesión',
  failedToSendReport: 'No se pudo enviar el informe',
  failedToGetReasons: 'No pude obtener razones',
  feelFreeToReachTextHD:
    ' Si cree que ha llegado a este mensaje por error o tiene alguna pregunta, póngase en contacto con nosotros.',
  fieldsForShopUse: 'Campos para uso del taller',
  filter: 'Filtrar',
  filterBy: 'Filtrar por',
  filterByDateRange: 'Filtrar por rango de fechas',
  filterResults: 'Filtrar resultados',
  filterSelectLines: 'Filtrar',
  filterSort: 'Filtrar y ordenar', // TODO
  filterSortResults: 'Filtrar y ordenar resultados',
  filterGroupSearch: 'Buscar %',
  filterGroupSearchNoResults: 'Sin resultados para "%"',
  applyFilters: 'Aplicar filtros',
  filterVehicles: 'Filtrar vehículos', // TODO
  fitmentConditions: 'Condiciones de montaje',
  failedToAcceptTermsAndConditions:
    'No se han aceptado los términos y condiciones', //TODO
  fitsYears: 'Para todos los años',
  for: 'para',
  forFullSweepstakesDetails: 'para ver todos los detalles del sorteo',
  forgotPassword: 'Contraseña olvidada',
  formIcomplete: 'Formulario incompleto',
  forShopUse: 'Sólo para uso en tienda',
  french: 'Francés',
  general: 'General',
  getLaborData: 'Obtener datos laborales',
  getThePerfectResults: 'OBTENGA LOS RESULTADOS PERFECTOS',
  getReport: 'Obtener informe',
  gfx: 'GFX',
  gfxCatalog: 'Catálogo GFX',
  gfxSpecificAndAttributeConditions: 'GFX Condiciones específicas y atributos',
  gfxUnavailableForThisVehicle: 'GFX no disponible para este vehículo',
  go: 'Ir a',
  goToAccessoriesSuppliesAndTools:
    'Ir a accesorios, suministros y herramientas (AST)',
  goToCart: 'Ir al carrito',
  goToFirstPage: 'Ir a la primera página',
  goToNextPage: 'Ir a la página siguiente',
  goToPreviousPage: 'Ir a la página anterior',
  grandTotal: 'Total general',
  graphicId: 'ID gráfico',
  group: 'Grupo',
  groupName: 'Nombre del grupo',
  groupNameAlreadyExists: 'El nombre del grupo ya existe',
  groups: 'Grupos',
  hashTagParts: '# Piezas',
  hasBeenRemovedFromYourCart: 'ha sido eliminado de su carrito.',
  hasChangedFrom: 'ha cambiado de ',
  here: 'aquí',
  hidden: 'oculto',
  hideMore: 'Ocultar más',
  home: 'Inicio',
  homePage: 'Página de Inicio',
  hours: 'Horas',
  howToReadThisGraphic: 'Cómo leer este gráfico',
  howToViewSearchResults:
    '¿Cómo te gustaría ver los resultados de tu búsqueda?',
  id: 'IDENTIFICACIÓN',
  ifYouDoNotReceiveEmailWithCode:
    'Si no recibe un correo electrónico con el código, póngase en contacto con su proveedor de piezas.', //TODO
  ifYouNeedThisGraphic:
    'si necesita este gráfico y trabajaremos en su solicitud lo antes posible.',
  ifYouThinkThisIsAMistakeContactYourAdministrator:
    'Si cree que se trata de un error, póngase en contacto con su administrador.', // TODO
  import: 'Importar',
  importantMessageAboutItemsInYourCart:
    'Mensaje importante sobre los artículos de su cesta',
  importComplete: 'Importación completada',
  importFile: 'IMPORTAR ARCHIVO',
  importFromFile: 'Importar desde archivo',
  importList: 'Importar lista',
  importListDescription:
    'Importe múltiples artículos a una lista desde un archivo CSV. Debe incluir columnas para Grupo, MFR, Número de Parte, Cantidad de Inventario y Comentarios.',
  importListTemplateCSV: 'Utilice nuestra plantilla de lista (CSV)',
  inCart: 'En la Cesta',
  increasedFromTo: '% pasó de % a %',
  interchange: 'Intercambio',
  interchangeResultsAreAvailableText: `Los resultados del intercambio están disponibles exclusivamente a través del catálogo de piezas MyPlace4. Al elegir intercambio, será redirigido a los resultados de MyPlace 4 Parts.`,
  interchangesearch: 'Búsqueda de Intercambio',
  interchangeSearchTextError: `La longitud del texto de intercambio debe estar entre 2 y 14 caracteres.`,
  interchangeDisclaimer:
    'Los resultados de intercambio son sólo de referencia. La aplicación debe ser verificada.',
  interchangeInfoMessage:
    'Si no encuentra el artículo que busca, pruebe a utilizar nuestra % para ver una lista completa de todas las partes de EO y de Aftermarket intercambiables con %.', // TODO
  interchangeTooltipHeading: 'INTERCAMBIO EN MP4P',
  interchangeFor: 'Intercambio por',
  invalidColumnNamesInTheUploadedFile:
    'Nombres de columna no válidos en el archivo cargado.', // TODO
  invalidListIdOrInvalidFile: 'ID de lista no válido o archivo no válido.', // TODO
  invalidEmailAddress: 'Dirección de correo electrónico no válida',
  invalidPartNumberOrLineCode: 'Número de pieza o código de línea no válido.', // TODO
  invalidRequestBody: 'Texto de la solicitud no válido.', // TODO
  invalidRequestParameters: 'Los parámetros de la solicitud no válidos.', // TODO
  invalidSearchPattern: `Patrón de búsqueda no válido`,
  invalidVin: 'VIN no válido',
  invoiceDetails: 'Detalles de la factura', //TO DO
  invoiceNumber: 'Número de factura',
  invoicedOn: 'Facturado el', //TO DO
  inputPartTypeThenHitEnter: `Ingrese el tipo de pieza y luego presione la tecla 'Intro' / 'Regresar' para buscar`, //TO DO
  isNotAvailableInDatabase: 'no está disponible en nuestra base de datos.',
  issueInAddingPartsToCart:
    'Hubo un problema al añadir sus artículos al carrito. Consulte la página del carrito para obtener más detalles.', //TODO
  item: 'Artículo',
  itemInYourCartCantBeFulfilled: '1 artículo en su carrito no se puede cumplir',
  itemInYourCartHasChangedPrice: '1 artículo de su cesta ha cambiado de precio',
  itemInYourCartHaveInsufficientQuantity:
    '1 artículo de su cesta tiene una cantidad insuficiente',
  items: 'Artículos',
  itemsAddedToTheCart: 'artículos añadidos a la cesta',
  itemsAvailability: '% de 8 disponibles',
  itemsInYourCartCantBeFulfilled:
    '% de artículos en su cesta no se pueden completar',
  itemWasnotAddedToYourCart: 'El artículo no se ha añadido a su carrito.', //TODO
  itemsInYourCartHaveChangedPrice:
    '% de artículos en su cesta han cambiado de precio',
  itemsInYourCartHaveInsufficientQuantity:
    '% artículos en su cesta tienen cantidad insuficiente',
  itemsPerPage: 'artículos por página',
  itemsReflectTheCurrentPrices: 'Los artículos reflejan los precios actuales',
  itemsRequireYourAttention: 'artículos que requieren su atención',
  itemsRestock: 'Artículos que se reponen cada cuatro meses',
  itemsSelected: 'artículos seleccionados a través de 1 lista',
  itemsWereNotTransferred: '% artículos no transferidos',
  itemsWillNotBeAddedToList: 'Los artículos no se añadirán a la lista.', // TODO
  itemUnavailable: 'Artículo no disponible en nuestra base de datos.',
  itemUnavailableAtAllLocations:
    'Artículo no disponible en todas las ubicaciones.',
  itemUnavailableAllLocations:
    '% artículo no disponible en todas las ubicaciones',
  itemsUnavailableAllLocations:
    '% artículos no disponibles en todas las ubicaciones',
  itemvalidated: 'Artículo validado',
  itemWasNotAdded: 'artículos no añadidos a su cesta',
  itemWasNotTransferred: '1 artículo no fue transferido',
  jobs: 'Trabajos',
  justAMoment: 'Sólo un momento',
  labor: 'Mano de obra',
  laborCost: 'Costo de mano de obra',
  laborData: 'Datos de mano de obra',
  laborId: 'ID de mano de obra',
  laborLookup: 'Búsqueda de mano de obra',
  laborOperationsDescriptions: 'Descripción de Operaciones Laborales',
  laborRate: 'Tarifa laboral',
  laborRatePerHour: 'Tarifa laboral por hora',
  laborsUpdated: 'Mano de obra actualizada',
  last7Days: 'Últimos 7 días',
  last12Months: 'Últimos 12 meses',
  last30Days: 'Últimos 30 días',
  lastUsed: 'Último utilizado',
  lastUsedAZ: 'Último uso (ascendente).', //TODO
  lastUsedZA: 'Último uso (descendente).', //TODO
  learnMore: 'Más información',
  license: 'Licencia',
  licensePlate: 'Matrícula',
  Lines: 'Lineas',
  lineCode: 'Código de línea',
  list: 'Lista',
  listBinDoesNotExist: 'La lista no existe.', // TODO
  listDeletionError: 'Error de borrado de lista',
  listHighLow: 'Lista (Alto-Bajo)',
  listImported: 'Lista importada con éxito',
  listImportedError: '% líneas contenían errores y no pudieron ser importadas',
  listImportedSuccessfully: 'Su lista se ha importado correctamente (% líneas)',
  listLookup: 'Búsqueda en la lista.', // TODO
  listLowHigh: 'Lista (Bajo-Alto)',
  listName: 'Nombre de lista',
  listNameAlreadyExists: 'El nombre de lista ya existe',
  listPrice: 'Precio de lista',
  listPriceBreakdown: 'Desglose del precio de catálogo',
  lists: 'Listas',
  loadingXResults: 'Cargando % de resultados.', // TODO
  location: 'Localización',
  locationChangedTo: 'Ubicación cambiada a',
  lookupDate: 'Buscar fecha',
  lookupItems: 'Buscar artículos',
  lookupSource: 'Fuente de búsqueda',
  lookupType: 'Tipo de búsqueda',
  logOut: 'cerrar sesión',
  lostSaleSuccess: 'Informe de venta perdida enviado',
  make: 'Marca',
  makeThisMyDefaultState: 'Hacer que este sea mi estado por defecto',
  manufacturer: 'Fabricante',
  manufacturers: 'Fabricantes',
  manufacturerInfo: `Si conoce el fabricante de la pieza que va a intercambiar, selecciónelo a continuación. Si no es así, haga clic en "Seleccionar todo".`, // TODO
  markAsFavorite: 'Marcar como favorito',
  markedAsFavorite: 'Marcar como favorito',
  mayNotFitYour: 'Puede que no sea compatible con el vehículo seleccionado.', // TODO
  mergeWithExistingCart: 'Fusionar con carrito existente',
  message: 'Mensaje',
  messageSent: '¡Mensaje enviado!',
  messageSentSuccess:
    'Gracias por su mensaje, alguien se pondrá en contacto con usted en función de su prioridad.',
  method: 'Método.', // TODO
  mfr: 'Mfr',
  mfrAZ: 'Fabricante (A-Z).', // TODO
  mfrZA: 'Fabricante (Z-A).', // TODO
  mileage: 'Kilometraje',
  minQty: 'Cant Mín',
  minQuantity: 'Cantidad mínima',
  miscellaneous: 'Misceláneos',
  missingPartInbox: 'Bandeja de entrada de piezas faltante',
  model: 'Modelo',
  more: 'más',
  moreLocations: 'Más Ubicaciones', // TODO - review
  moreOptions: 'Más opciones',
  moreActions: 'Más acciones',
  move: 'Mover',
  moveGroup: 'Grupo Move',
  moveItems: 'Mover artículos',
  moveList: 'Mover lista',
  moveToAnotherList: 'Mover a otra lista',
  mustIncludeAPartToOrderThisCart:
    'debe incluir una parte para pedir este carro',
  multiPartInquiry: 'consulta de varias partes',
  multiPartInquiryValidationError:
    'Código de línea no válido, los caracteres especiales no están permitidos/la longitud del código de línea debe tener un mínimo de 2 caracteres y un máximo de 3 caracteres',
  myStore: 'Mi tienda',
  myPlaceForParts: 'MyPlace4Parts',
  multiSellerIntegrationNotResponding:
    'Multi-Seller integration is not responding for this seller. Please contact us for support',
  name: 'Nombre',
  needHelpResettingYourPassword:
    '¿Necesita ayuda para restablecer su contraseña?',
  new: 'Nuevo',
  newCategory: 'Nueva categoría',
  newGroup: 'Grupo Nuevo',
  newList: 'Lista Nueva',
  newLists: 'Listas Nuevas',
  newParts: 'Piezas Nuevas',
  newPassword: 'Contraseña nueva',
  newReturn: 'Nuevo regreso',
  next: 'Siguiente',
  nextChooseList: 'Siguiente',
  nextSelectGroup: 'SIGUIENTE',
  nextSelectDescription: 'SIGUIENTE: seleccionar descripcion',
  nextSelectPartTypes: 'SIGUIENTE',
  noAdditionalDetails: 'No hay detalles adicionales',
  noData: 'No hay datos disponibles',
  noDataForTheGivenPartDetails:
    'No hay datos para los detalles de la pieza indicada', // TODO
  noImage: 'No hay imagen disponible',
  noMoreResults: 'No hay más resultados',
  noOrdersAvailable: 'No hay pedidos disponibles',
  noInvoicesAvailable: 'No hay facturas disponibles', //TODO
  noPartsFoundForThisGroup: 'No se han encontrado piezas en este grupo',
  noPartsFoundForThisList: 'No se han encontrado piezas en esta lista', // TODO
  noPartsFoundAddedToCart: 'No se han añadido piezas al carrito', // TODO
  noPartsCanBeAddedToCart:
    'Ninguna de las piezas puede añadirse al carrito ya que provienen de ubicaciones de solo visualización',
  noQuotesAvailable: 'No hay cotizaciones disponibles',
  noResults: 'Sin resultados', //To DO
  noResultsFound: 'No se han encontrado listas',
  noResultsFoundForHD: `NO SE HA ENCONTRADO NINGÚN RESULTADO PARA "%"`,
  noListResultsFound: 'No se han Encontrado en las Listas', //TO DO
  noResultsFoundForThisVehicle:
    'No se han encontrado resultados para este vehículo',
  normal: 'Normal',
  note: 'Nota',
  notes: 'notas',
  noteToStore: 'Nota a la tienda',
  notesToStore: 'Notas a la tienda',
  noVehicleHistoryAvailable: 'No hay historial disponible',
  oeCrossReference: 'Referencias cruzadas OE', //TODO
  oePart: 'Pieza OE',
  oeParts: 'Piezas de Equipo Original', //TODO
  oePartNumbersDisclaimer:
    'Los números de pieza OE son sólo para referencia. La aplicación debe ser verificada.',
  okIUnderstand: 'Ok, entiendo',
  optional: 'Opcional',
  onThisOrderFor: 'en este pedido para',
  onThisOrderForAnAutomaticEntry: 'en este pedido para una entrada automática.',
  onlineCatalog: 'Catálogo en línea',
  onlyLaborResultsAreAddedToCart:
    'Solo se añaden al carrito los resultados de mano de obra', //TODO
  onlyOutOfRequestedAreAvailable: 'Sólo % de % solicitados están disponibles',

  onlySpecsAreAddedToCart: 'Solo se añaden al carrito las especificaciones', //TODO
  onlySpecsLaborResultsAreAddedToCart:
    'Solo se añaden al carrito las especificaciones y los resultados de mano de obra', //TODO
  'Only Priced': 'Solo Precio',
  'Only Stocked': 'Solo Disponible',
  openGroups: 'Grupos abiertos',
  or: 'O',
  order: 'Pedir',
  orderAllCarts: 'Pedir todos los carros',
  orderConfirmation: 'Confirmación del pedido',
  orderConfirmationError:
    'Revise el mensaje de error anterior y vuelva a enviar su pedido desde la página del carrito. Si sigue teniendo problemas, póngase en contacto con nosotros.',
  orderAllCartsConfirmation:
    '¿Está seguro de que desea pedir todos los carritos?', // TODO
  orderDate: 'Fecha del pedido', // TODO
  orderDetails: 'Detalles del pedido',
  ordered: 'Pedido',
  orderedBy: 'Ordenado por',
  orderedON: 'Pedido el',
  orderedOn: 'Pedido el %',
  orderedFrom: 'Pedido de',
  orderFailed: 'Orden fallida',
  orderForm: 'Formulario de pedido',
  orderFormIsIncomplete: 'El formulario de pedido está incompleto.',
  orderHistory: 'Historial de pedidos',
  orderNotFound: 'Pedido no encontrado',
  orderNumber: 'Número de pedido',
  orders: 'Pedidos',
  orderError: 'Error: El pedido falló. ',
  orderSummary: 'Resumen del pedido',
  orderThisCart: 'PEDIR ESTE CARRITO',
  orderTotal: 'Total del pedido',
  orderFromPrimaryWarining:
    'Los pedidos a esta ubicación serán procesados ​​por su tienda local.',
  OrdersWillBeProcessedByYourLocalStore:
    'Los pedidos serán procesados ​​por su tienda local.',
  orderType: 'Tipo de pedido',
  orderConfirmationNumber: 'Confirmación del pedido Id', //TODO
  other: 'Otro (Especifique)',
  others: 'Otro',
  otherSellers: 'Otros vendedores',
  outOf: 'agotado',
  outOfStock: 'Fuera de stock',
  outOfStockAtAllLocationsWillBeOrderedFromOtherStore:
    'agotado en todas las ubicaciones, se pedirá a %.',
  outOfStockAtUpdatedTo: 'agotado en %, actualizado a %.',
  packed: 'Empacado',
  page: 'Página',
  part: 'Pieza',
  'Part#': 'Parte #',
  partIsValidSubText: `Puede utilizar nuestra herramienta de referencias cruzadas para ver una lista completa de todas las piezas OE y del mercado de accesorios intercambiables con % o intentar otra búsqueda`,
  partIsValidText: `% es un número de pieza válido, pero no disponemos de esta pieza ni ningún producto intercambiable.`,
  partVehicleFitment: 'Pieza', //TO DO
  partAvailableInAnotherGroup: 'Pieza disponible en otro grupo',
  partAvailableInCurrentScreen: 'Pieza disponible en la pantalla actual',
  partDescription: 'Descripción de la pieza',
  partDescriptionAZ: 'Descripción de la pieza (A-Z)',
  partDescriptionZA: 'Descripción de la pieza (Z-A)',
  partNum: 'Número de pieza',
  partNumber: '# de pieza',
  partNumberRequired: 'N.º de pieza (Obligatorio)',
  partNumberRequiredShort: 'N.º de pieza',
  partNumberAZ: 'Número de pieza (A-Z)',
  partNumberZA: 'Número de pieza (Z-A)',
  partsCatalog: 'Catálogo de piezas',
  partSelected: 'Pieza seleccionada',
  partType: 'Tipo de pieza',
  PartType: 'Tipo de pieza',
  partTypes: 'Tipo de pieza',
  partInquiry: 'Tipo Consulta',
  partWasAddedToYourCart: '%fue añadido a su carrito',
  partWasRemovedFromYourCart: '%fue removido de su carrito',
  partsHaveBeenAddedToYourCart: 'Se han agregado piezas a su carrito',
  password: 'Contraseña',
  passwordReset: 'Restablecer contraseña',
  passwordsMustMatch: 'Las contraseñas deben coincidir',
  pending: 'pendiente',
  perCarQty: 'Cant por coche',
  personalNote: 'Nota personal',
  phoneNumber: 'Número de teléfono',
  phoneNumberRequired: 'Número de teléfono requerido',
  pleaseContactForInformation: 'Comuníquese con % para obtener información',
  pleaseEnterTheCodeThatWasSentTo:
    'Por favor, ingrese el código que se envió a %.',
  pleaseEnterYourContactDetailsAndAnAdminWillBeInContactWithYou:
    'Por favor, ingrese su nombre de usuario, dirección de correo electrónico y número de teléfono, y un administrador se comunicará con usted',
  pleaseEnterYourScreenNameToSendVerificationCode:
    'Favor de ingresar su nombre de usuario para enviar un código de verificación a su correo electrónico',
  pleaseReviewAndAcceptEulaAbove: 'Por favor, revise y acepte el EULA anterior',
  pleaseUploadValidCsvFile: 'Cargue un archivo CSV válido',
  pleaseUploadCsvFile: 'por favor cargue el archivo csv',
  pleaseReviewTheFollowingMessageBeforeConfirmingYourOrder: `Por favor, revise el siguiente mensaje antes de confirmar su pedido. Puede continuar con su pedido tal como está, volver a su carrito de compras para hacer cambios, o eliminar artículos específicos o todo el carrito de su pedido. Los artículos eliminados permanecerán en la página de su carrito para más adelante.`,
  po: 'OC',
  poNumber: 'Número de pedido',
  poNumberIsTheSameForAllSellers:
    'El número de pedido es el mismo para todos los vendedores.',
  previousSearches: 'Búsquedas anteriores',
  price: 'Precio',
  pricePerItem: 'Precio por artículo',
  primary: 'Primaria',
  print: 'Imprimir',
  printList: 'Imprimir lista',
  printCatalogDiagram: 'Imprimir Diagrama de Catalogo', //TODO
  priority: 'Prioridad',
  ProcessedByLocalStore: 'Procesado por la tienda local',
  productCantBeFulfilledFromSelectedLocation:
    'El producto no se puede suministrar desde la ubicación seleccionada.', //"TO DO"
  productCantBeFulfilled:
    'El producto no se puede suministrar desde ninguna ubicación',
  productToThisOrderForAnAutomaticEntry:
    'producto a este pedido para una entrada automática.',
  products: 'Productos',
  productsWereAddedToTheCart: 'Los productos se han añadido a la cesta',
  promoPolicy:
    'para conocer todos los detalles del Sorteo. *Estimación. El recuento real de participaciones en MyPlace4Parts se actualizará en un plazo de 24-48 horas.',
  qty: 'Cantidad',
  qtyAZ: 'Cantidad (menor-mayor)', //TODO
  qtyZA: 'Cantidad (mayor-menor)', //TODO
  qtyPriceBreak: 'Cantidad Precio',
  qtyToReturn: 'CANTIDAD A DEVOLVER',
  quantity: 'Cantidad',
  quantityPriceBreak: 'Cantidad Precio de ruptura',
  quantityRequestedIsLessThanMinimum:
    'La cantidad solicitada es inferior a la mínima.',
  quantityRequestedHasChanged: 'La cantidad solicitada ha cambiado.',
  quoteAmountText: `La cotización total representa el costo de todos los productos más la mano de obra.`,
  quoteDeletedSuccessfully: '% Se ha eliminado correctamente  ',
  quoteDetails: 'Detalles de la Cotización',
  quoteId: 'Cotización ID',
  quoteNotFound: 'Presupuesto no encontrado',
  quoteNumber: 'Cotización #%',
  quoteTotal: 'Total de la cotización',
  quoteUpdatedMsg: `La cotización se actualizó exitosamente`,
  quotes: 'Cotizaciones',
  quote: 'Cita',
  quotesOlderThan: 'cotizaciones anteriores a',
  quoteSummary: 'Resumen de la cotización',
  quoteVehicleNotFound:
    'Información del vehículo de la cotización no encontrada',
  rate: 'Valore',
  readLess: 'Leer menos',
  readMore: 'Leer Más',
  reason: 'Razón',
  reasonForReturn: 'RAZÓN PARA REGRESAR',
  recentOrders: 'Pedidos recientes',
  recentSearches: 'Búsquedas recientes',
  recentVehicles: 'Vehículos recientes',
  recommended: 'Recomendado',
  recommendedProductsFromYourSeller: 'Productos recomendados por su vendedor.', // TODO
  recommendedServices: 'Servicios Recomendados',
  refreshPage: 'Actualizar página',
  regular: 'Regular',
  removeAll: 'Eliminar todo',
  removeAllCarts: 'Quitar todos los carros',
  removeCart: 'Eliminar carro',
  removeItem: 'Remover el artículo',
  removeItemFromReturnRequest:
    'Eliminar artículo de la solicitud de devolución',
  removeYour: 'Eliminar su',
  removeCartFromOrder: 'Eliminar carrito del pedido',
  removeItemFromOrder: 'Eliminar artículo del pedido',
  removeVehicleCart: 'Eliminar carrito %',
  rename: 'Renombrar',
  reName: 'Renombrar',
  renameCategory: 'Renombrar Categoría',
  reNameGroup: 'Renombrar grupo',
  renameList: 'Renombrar lista',
  replacementFor: 'Sustitución de',
  reportLostSale: 'Informar de venta perdida',
  requestDetails: 'Detalles de la solicitud',
  requestAdditionalSellers: 'Solicitar vendedores adicionales',
  requestNewCode: 'Solicitar un nuevo código',
  requestPasswordReset: 'Solicitar restablecimiento de contraseña',
  resetYourPassword: 'Restablecer contraseña',
  resortItems: 'Reordenar elementos',
  results: 'Resultados',
  resultsFilter: 'Resultados Filtrar',
  resultsLoaded: 'Resultados cargados', // TODO
  returnAmountText:
    'Este monto se acreditará en su cuenta una vez que se proceda y autorice la solicitud de devolución.',
  returnRequest: 'Solicitud de Devolución',
  returnRequestDetails: 'Detalles de la solicitud de devolución',
  requestReturn: 'Solicitar devolución',
  requestReturnId: 'Solicitar ID de devolución',
  resultsTableDensity: 'Densidad de la tabla de resultados',
  returnToThePartsCatalogToKeepShopping:
    'Volver al catálogo de piezas para seguir comprando.',
  returnToVehicleHistory: 'Volver al historial del vehículo', // TODO
  returnToCart: 'Volver al carrito',
  reviewItemsaddedtocart: 'Revisar artículos añadidos a la cesta',
  reviewTheItemsYouWishToAddToList:
    'Revise los artículos que desea añadir a la lista',
  reviewTheItemsYouWishToAddToThisGroup:
    'Revise los artículos que desea añadir a este grupo',
  rma: 'RMA',
  rmaRequest: 'Solicite RMA',
  rmaConfirmation: 'Confirmación de RMA',
  rollOverImageToMagnify:
    'Pase el cursor por encima de la imagen para ampliarla',
  save: 'Guardar',
  saveAll: 'Guardar todo',
  saveAsQuote: 'Guardar como presupuesto',
  saveChanges: 'Guardar cambios',
  savePreferences: 'Guardar Preferencias',
  screenName: 'Nombre de pantalla',
  screenNameRequired: 'Nombre de pantalla requerido',
  search: 'Buscar',
  searchSettings: 'Configuración de búsqueda',
  searchAllOrders:
    'Buscar pedidos (por orden de compra, número de pieza, vehículo)',
  searchAllInvoices:
    'Buscar en todas las facturas (por PO, número de pieza, número de factura)', //TO DO
  searchAllQuotesBy:
    'Buscar todas las cotizaciones (por orden de compra, número de pieza, notas, ubicación)',
  searchByLicensePlate: 'Buscar por matrícula',
  searchByVin: 'Buscar por VIN',
  searchByYMME: 'Buscar por año, marca, modelo',
  searchDate: 'Buscar por fecha',
  searchForVehicles:
    'Búsqueda de vehículos (nombre personalizado, matrícula...)',
  searchManufacturers: 'Buscar por fabricante',
  searchOnWeb: 'Buscar en la web',
  searchPartBrandName: 'Buscar nº de pieza, marca o nombre de pieza',
  searchParts: 'Buscar piezas',
  searchSalesPadUsersIndications:
    'Buscar usuarios (nombre de cuenta, nombre de organización)',
  searchWithinResults: 'Buscar dentro de los resultados',

  searchbyPartTypes: 'Buscar por tipos de piezas',
  secondary: 'Secundaria',
  seeLess: 'Ver menos',
  seeMore: 'Ver más',
  select: 'Seleccione',
  selectACart: 'Seleccionar un carrito',
  selectAReason: 'Selecciona una razón',
  selectAConditionToChangeGraphic:
    'Seleccione una condición para cambiar el gráfico mostrado',
  selectAll: 'Seleccionar todo',
  selectAllItemsInThisList: 'Seleccione todos los artículos en esta lista',
  selectAVehicle: 'Seleccione un vehículo',
  selectAnotherLocation: 'Seleccionar otra ubicación', //TO DO
  selectCartToAddItem: 'Seleccionar cesta para añadir artículo',
  selectCategory: 'Seleccionar categoría',
  selected: 'seleccionado',
  selectedAcross: 'seleccionado a través de',
  selectFromManufacturer: `Seleccion "desde el" Fabricante`,
  selectFromManufacturerDescription: `Optimizar mi búsqueda de intercambio mostrando primero todos "desde los"
fabricantes que corresponden al número de pieza específico antes de mostrar mis
resultados`,
  selectedLines: 'Líneas seleccionadas',
  sellerOrder: 'Pedido de %',
  selectGfxAndFitmentConditions: 'Seleccione GFX y condiciones de montaje',
  selectGroup: 'Seleccionar grupo',
  selectManufactureLines:
    'Seleccione las líneas de fabricantes con las que desea filtrar los resultados.',
  selectManufacturersUpto: 'Puede seleccionar hasta 10 fabricantes.',
  selectOneOrMoreCategoriesToDisplayCorrespondingGroups:
    'Seleccione una o más categorías para mostrar los grupos correspondientes', // TODO: review
  selectOneOrMoreCategoriesToDisplayCorrespondingJobs:
    'Seleccione una o más categorías para mostrar los trabajos correspondientes', // TODO
  selectOneOrMoreGroupsToDisplayCorrespondingPartTypes:
    'Seleccione uno o más Trabajos para mostrar los tipos de Pieza Correspondientes', // TODO: review
  selectOneOrMoreJobsToDisplayCorrespondingPartTypes:
    'Seleccione uno o más trabajos para mostrar los tipos de piezas correspondientes', // TODO
  selectMethod: 'Seleccionar método', // TODO
  selectPartType: 'Seleccione el tipo de pieza',
  selectPartTypes: 'seleccionar tipos de pieza', // TODO
  selectThenBy: 'Seleccionar entonces por',
  selectVehicle: 'Seleccionar vehículo',
  selectVehicleEngine: 'Seleccione el motor del vehículo',
  selectYourPreferredDefaultVehicleTypeWhenDoingAYMMESearch:
    'Seleccione su tipo de vehículo preferido para búsquedas AMMM', // TODO: review
  sendAMessageTo: 'Enviar un mensaje a',
  sendAnother: 'Enviar otro',
  sendCode: 'Enviar Código',
  sendMessage: 'Enviar Mensaje',
  sendUsaMessage: 'Envíanos un mensaje',
  separateMultiplePartNumbers: 'Separe varios números de pieza con espacios',
  separateMultiplePartNumbersWithSpaces:
    'Separe varios números de pieza con espacios',
  serviceIntervals: 'Intervalos de servicio',
  servicesIntervalType: 'Tipo de Intervalo de Servicios',
  setLaborRate: 'Establecer tarifa de mano de obra',
  severe: 'Severo',
  shipByCourier: 'Enviar por mensajería',
  shipTo: 'Enviar a',
  shipment: 'Envío',
  shipmentCost: 'Gastos de envío',
  shipped: 'Enviado',
  shippedFrom: 'Enviado desde',
  shipping: 'Envío',
  shippingCostIsUpdated:
    'Su costo de envío ha cambiado según la cantidad actualizada',
  shippingId: 'ID Envío',
  // i.e: 'Mostrando 1-10 de 391 Pedidos',
  'Show All': 'Mostrar Todo',
  showGraphic: 'Mostrando gráfico',
  showing: 'Mostrando',
  showingResultsFor: 'Mostrando resultados de',
  showResults: 'Mostrar resultados',
  showLess: 'Mostrar menos', // TODO
  showMore: 'Mostrar más', // TODO
  skillLevel: 'Nivel de habilidad',
  skipAndSeeAllResults: 'Saltar y ver todos los resultados',
  sort: 'Ordenar',
  sortBy: 'Ordenar Por',
  sortGroup: 'Ordenar grupo',
  sortHasNotYetBeenApplied: 'Aún no se ha aplicado el orden',
  sortMultiSellerTabs: 'Ordenar pestañas de varios vendedores',
  sortResult: 'Ordenar resultados',
  sortSellers: 'Ordenar Vendedores',
  sortSellerDrawerInstructions:
    'Arrastre y suelte los vendedores disponibles para organizarlos en el orden de visualización que prefiera.',
  spanish: 'Español',
  source: 'Fuente',
  soldBy: 'Vendido por %',
  specifications: 'Especificaciones',
  specificationSearch: 'Buscar especificaciones',
  specificationUpdate: 'Especificaciones actualizadas',
  specify: 'Especifique si es otro',
  startNewCart: 'Iniciar nuevo carro',
  state: 'Estado',
  status: 'Estado',
  statusUnavailable: 'Estado No disponible', // TODO
  stock: 'Existencias',
  stockOptionAll: 'Todos',
  stockOptionInStock: 'En existencia',
  subject: 'Asunto',
  submit: 'entregar',
  subOperation: 'Sub Operación',
  subModelOptional: 'Submodelo (Opcional)',
  successfullyCreatedCategory: 'Categoría creada con éxito',
  successfullyCreatedGroup: 'Grupo creado con éxito',
  successfullyCreatedList: 'Lista creada con éxito',
  successfullyDeletedCategory: 'Categoría eliminada con éxito',
  successfullyDeletedGroup: 'Grupo eliminado con éxito',
  successfullyDeletedList: 'Lista eliminada con éxito',
  successfullyListMoved: 'Lista movida correctamente',
  successfullyUpdatedCategory: 'Categoría actualizada correctamente',
  successfullyUpdatedGroup: 'Grupo actualizado correctamente',
  successfullyUpdatedList: 'Lista actualizada correctamente',
  summary: 'Resumen',
  switchOrg: 'Cambiar organización', //TODO
  theFollowingItemsWereLoaded:
    'Los siguientes elementos se cargaron después de aplicar una ordenación personalizada. Para aplicar su ordenación a los elementos a continuación, haga clic en reordenar elementos',
  theMinimumOrderQuantityIs: 'La cantidad mínima de pedido es %.',
  thenBy: 'Luego por',
  thePartWasAddedToYourCart: 'La pieza ha sido añadida a su cesta',
  fewOfThePartsWereNotAddedToCart:
    'Algunas de las piezas no se han añadido al carrito', //TODO
  NoPartWasNotAddedToTheCart: 'No se ha añadido ninguna pieza a su carrito', //TODO
  theQuantityRequestedIsNotAvailable:
    'La cantidad solicitada no está disponible',
  theseItemsWereUnavailableFromOurDatabase:
    'Estos artículos no estaban disponibles en nuestra base de datos',
  thesePartsMayNotFitYour: 'Puede que estas piezas no se ajusten a su',
  theseTicketsWillNotBeSentOnTheTicketToTheWarehouse:
    'Estos campos no se enviarán en el ticket al almacén.',
  theServerDidNotRespondOnTimePleaseTryAgainInAFewMoments:
    'El servidor no ha respondido a tiempo. Vuelva a intentarlo dentro de unos minutos.', // TODO
  thisCannotBeUndone: 'Esto no se puede deshacer.',
  thisGroupIsEmpty: 'ESTE GRUPO ESTÁ VACÍO',
  thisIncludesTheFollowingCarts: 'Esto incluye los siguientes carros',
  thisItemWasUnavailableFromOurDatabase:
    'Este artículo no estaba disponible en nuestra base de datos',
  thisOrderHasQualifiedFor: 'Este pedido ha calificado para',
  thisOrderWasPlacedThroughAnotherSellerAndTrackingIsUnavailable:
    'Este pedido se realizó a través de otro vendedor y el seguimiento no está disponible.',
  thisQuoteCantBeFulfilled: 'Este presupuesto no se puede cumplir.',
  thisVinIsInvalidTryAgain:
    'Este número VIN no es válido. Favor de verificar el número VIN e inténtelo de nuevo',
  invalidQuery:
    'Consulta no válida, el término de búsqueda debe tener al menos 3 caracteres.', //TODO
  thisWillRemoveAllItemsFromTheCartAndCannotBeUndone:
    'Esto eliminará todos los artículos de la cesta y no se puede deshacer.',
  today: 'Hoy',
  to: 'a',
  toEnsureWeCanFindTheBestMatchPleaseEnterVehicleInformation:
    'Para asegurarnos de que podemos encontrar la mejor coincidencia, introduzca la información del vehículo.',
  tomorrow: 'Mañana',
  total: 'Total',
  totalApplications: 'Total de solicitudes',
  toHideAnItemClickTheEyeIcon:
    'Haga clic sobre el ojo para esconder un elemento', // TODO: review
  totalCost: 'Costo total',
  totalHours: 'Total Horas',
  totalList: 'Total Lista',
  totalQty: 'Total CANT',
  trackingHistory: 'Historial de seguimiento',
  trackingInformationIsNotYetAvailable: `La información de seguimiento aún no está disponible para este envío, vuelva a intentarlo más tarde.`, //TODO
  trackingShipment: 'Seguimiento de envíos',
  transfer: 'Transferencia',
  transport: 'Transporte',
  tryAdjustingYourFilters: 'Intente ajustar sus filtros',
  tryAdjustingYourSearchOrLookupPartsInOurDatabase:
    'Intente ajustar su búsqueda o buscar piezas en nuestra base de datos',
  tryAgain: 'Intentar otra vez',
  tryANewSearchOrEditYourFitmentConditions:
    'Intente una nueva búsqueda o edite sus condiciones de montaje',
  tryANewSearchOrUseThePartsCatalog:
    'Intente una nueva búsqueda o utilice el catálogo de piezas',
  trySelectingDifferentGroups:
    'Intente seleccionar grupos diferentes o buscar otro vehículo',
  tryUsingADifferentKeywordCheckingForTyposOrAdjustingYourFilters:
    'Pruebe con una palabra clave diferente, revise si hay errores de escritura o ajuste sus filtros',
  type: 'Escriba',
  typeANameForThisVehicle: 'Escriba un nombre para este vehículo',
  unableToFetchManufacturer: 'No se puede obtener el fabricante',
  unableToFetchPartTypes: 'No se pueden obtener los tipos de piezas',
  unableToPlaceOrder: 'No se puede realizar el pedido',
  unableToPlaceOrderError: `No se puede realizar el pedido: Consulta de piezas/Error de pedido`,
  unableToPlaceOrderPleaseContactTheAdministrator:
    'No se ha podido realizar el pedido. Póngase en contacto con el administrador.',
  unavailableGroupGraphic: 'Gráfico de grupo no disponible',
  unavailablePartTypes: 'Tipos de piezas no disponibles',
  unavailableProductDetails: 'Detalles del producto no disponibles',
  unableToConnect: 'No se puede conectar',
  unableToFetchSellers: 'No se pueden recuperar vendedores',
  underWarranty: 'Bajo garantía',
  unDone: 'Esto no se puede deshacer.',
  unknownAftermarketAvailability: 'Disponibilidad desconocida',
  unknownError: 'Un error desconocido ocurrió',
  update: 'Actualizar',
  updateCart: 'Actualizar cesta',
  updateList: 'Actualizar Lista',
  updateQuote: 'Actualizar presupuesto',
  updateVehicle: 'Actualizar vehículo',
  updatingYourVehicleWillChangeSearch:
    'Actualizar su vehículo cambiará los resultados de su búsqueda actual.¿Desea actualizar?',
  urgent: 'Urgente',
  user: 'Usuario',
  usedPartInbox: 'Bandeja de entrada de piezas usadas',
  useTemplateCsv: 'Utilice nuestra lista de plantillas (CSV)',
  vehicle: 'Vehículo',
  vehicleClear: 'borrar',
  vehicleDeleted: 'Vehículo eliminado',
  vehicleDeletedSuccessfully: 'Vehículo eliminado con éxito',
  vehicleFitment: 'Equipamiento del vehículo',
  vehicleFitmentUnavailable:
    'El equipamiento del vehículo no está disponible para este producto.',
  vehicleHistory: 'Historial del vehículo',
  vehicleIncomplete: 'Vehículo incompleto',
  vehicleInformationWasIncomplete:
    'La información del vehículo estaba incompleta. Por favor, añada los datos restantes del vehículo',
  vehicleInfoRetrievalError:
    'Se ha producido un error al intentar recuperar la información del vehículo.', // TODO
  vehicleLicensePlate: 'Matrícula',
  vehicleNotFound: 'Vehículo no encontrado',
  vehicleQuickFind: 'Búsqueda rápida de vehículos', // TODO
  vehicleRequired: 'Vehículo requerido',
  vehicleRequiredForSearch: 'Por favor, seleccione un vehículo para continuar.',
  vehicles: 'Vehículos',
  vehicleSearch: 'Buscar vehículo',
  vehicleSpecification: 'Especificación',
  vehicleSuccessfullyDeleted: 'Vehículo eliminado con éxito',
  vehicleTotal: 'Total del Vehículo',
  vehicleType: 'Tipo de vehículo',
  vehicleTypeDropdown: 'menú desplegable de tipos de vehículo', // TODO: review
  vehicleVIN: 'VIN',
  vehicleYMME: 'Año/Marca/Modelo/Motor',
  verifyingQuantityAvailable: 'Verificando cantidad disponible...',
  verifyingTheItemsInOurDatabase:
    'Verificando artículos en nuestra base de datos...',
  verifyingTheLocationForItems:
    'Verificación de la ubicación de los artículos...',
  viewCart: 'Ver Cesta',
  viewDetails: 'Ver detalles',
  viewIn360: 'Ver en 360°',
  viewLists: 'Ver listas',
  viewMore: 'Más información',
  viewOnly: 'Ver sólo',
  viewOnlyLocationMessage:
    'Solo visualización de ubicación. Seleccione su almacén o tienda local para realizar el pedido.', // TODO
  viewOrderDetails: 'Ver detalles del pedido',
  viewOrPrint: 'Ver o imprimir recibo',
  viewOrPrintQuote: 'Ver o imprimir presupuesto',
  viewPartAvailabilityInListBelow:
    'Ver disponibilidad de piezas en la siguiente lista',
  viewQuotes: 'Ver cotizaciones',
  viewPreviousSearches: 'Ver búsquedas anteriores',
  viewQuoteDetails: 'Ver detalles de presupuestos',
  viewVinDetails: 'Ver detalles Vin',
  vin: 'VIN',
  vinAutoCorrected: 'Número de VIN corregido automáticamente a %',
  vinScan: 'VIN escanear',
  vinCode: 'Código VIN',
  vinDetails: 'Detalles del VIN',
  vinMustContain17Characters: 'VIN debe contener 17 caracteres',
  vinPattern: 'Patrón VIN',
  visitTheWebsiteForOrderDetails:
    'Visite el sitio web para detalles de la orden',
  warranty: 'Garantía',
  warrantyHours: 'Horas de garantía',
  warrantyInfo: 'Información de Garantía',
  wasSavedAsQuote: '% fue guardado como cotización',
  wasAddedToList: 'fue añadido a la lista',
  weAreUnableToRequestReturnsFromThisSellerDisclaimer:
    'No podemos solicitar devoluciones para este vendedor. Póngase en contacto directamente con el vendedor para devolver artículos de este pedido.',
  weAreValidatingAvailability: 'Estamos validando la disponibilidad.',
  weWereUnableToProcessYourRequest:
    'No pudimos procesar su solicitud. Vuelva a intentarlo y, si el problema persiste, póngase en contacto con su proveedor de piezas.',
  weight: 'Peso',
  wereSorryAGraphicFor: 'Lo sentimos, un gráfico para',
  wereSorryTheProductDetailsFor:
    '% de artículos en su carrito no se puede cumplir',
  whyAreYouReturningThisPart: '¿Por qué devuelves esta parte?',
  wrongPartFromCatalog: 'Pieza incorrecta del catálogo',
  wildCardSearchNotAllowedText: `No se permite la búsqueda con comodines`,
  wtyHours: 'Horas WTY',
  year: 'Año',
  years: 'Años',
  yesEmpty: 'Sí, vacío',
  yesIUnderstand: 'Sí, entiendo',
  yesterday: 'Ayer',
  youHaveMultipleOpenCartsInYourShoppingCart:
    'Tiene varios carritos abiertos en su carrito de compras',
  youHaveReachedTheMaximumNumberOfEntries:
    'Ha alcanzado el número máximo de entradas',
  youHaveEntryToDate: 'Tiene % de entradas hasta la fecha.', // TODO
  yourCartIsEmpty: 'Su cesta está vacía',
  yourCartWasSuccessfullyEmptied: 'Tu cesta se ha vaciado correctamente.',
  yourCost: 'Su costo',
  yourFiltersReturnedNoResults: 'Sus filtros no han dado ningún resultado',
  yourFirstItemWillBeYourDefault: 'Su primer elemento será el predeterminado',
  yourSearchReturnedNoResults: 'Su búsqueda no ha dado ningún resultado',
  zeroAvailableAtLocation: '0 disponible en %',
  'Not Available': 'No disponible',
  'Price Too High': 'Demasiado caro',
  'Prefer Different Brand': 'Prefiero una marca diferente',
  oopsSomethingWentWrong: '¡Ups! Algo salió mal',
  Other: 'Otros',
  otherInfo: 'Otra',
  CAR: 'COCHE / AUTOMOVIL', //TO DO
  TRUCK: 'CAMIÓN', //TO DO
  'MEDIUM DUTY': 'SERVICIO MEDIO', //TO DO
  '# Parts': '# Piezas',
  addPartsToGroup: 'Añadir piezas al grupo',
  addPrompt: `Añadir aviso`,
  addTheItemsYouWishToIncludeInThisGroup:
    'Añada los artículos que desea incluir en este grupo',
  additionalResources: 'Recursos adicionales',
  aftermarketAutoPartsAlliance: 'Alianza de piezas de automóvil de recambio',
  and: 'y',
  arrivingOn: 'Llegando al %',
  ast: 'AST',
  associatedOrganizations: 'Organizaciones asociadas',
  backToHome: 'Volver a la página de inicio',
  basicDetails: 'Detalles básicos',
  bundleEligible: 'Paquete elegible',
  bundleSavings: 'Ahorro por paquete:',
  bundleSavingsWithOutColon: 'Ahorro por paquete',
  buyer: 'Comprador',
  cancelRequest: 'Cancelar solicitud',
  chooseFile: 'Elegir archivo',
  chooseMethod: 'Elegir método',
  comment: 'Comentario',
  confirmationNumber: 'Número de confirmación',
  contactUsFormErrorMessage:
    'Se ha producido un error. Inténtelo de nuevo más tarde',
  continue: 'Continuar',
  controlID: 'ID de control',
  deliveryTime: 'Tiempo de entrega',
  deselectAll: 'Deseleccionar todo',
  directOrder: 'Pedido directo',
  discardAndStartNew: 'Desechar y comenzar un nuevo',
  discardAndStartNewCartMessage:
    'Tiene artículos en el carrito para el vehículo actual. ¿Desea descartar estos artículos y comenzar un nuevo pedido?',
  discardChanges: 'Descartar cambios',
  documentID: 'ID del documento',
  dragAndRearrangeTheItemsInThisList:
    'Arrastre y reorganice los artículos de esta lista',
  duplicateFound: 'Duplicado encontrado',
  duplicateItemsFoundWithMatchingPartNumbers:
    'Se han encontrado artículos duplicados con números de pieza coincidentes',
  dragAndDropItHere: 'o arrástrelo y suéltelo aquí',
  enterItems: 'Introducir artículos',
  errorInReloadingVehicleFitments:
    'Error al recargar los accesorios del vehículo',
  errorUpdatingLaborRate: 'Error al actualizar la tarifa de mano de obra',
  estimatedReturn: 'Devolución estimada',
  goToASTCatalog: 'Ir al catálogo de No-Aplicaciones',
  goToHome: 'Ir a la página de inicio',
  goToProductPage: 'Ir a la página del producto',
  hasNMatches: 'Tiene % coincidencias',
  hold: 'Retener',
  importMultipleItemsFromCSVFile:
    'Importar varios artículos desde un archivo CSV',
  itemsWereNotAddedToYourCart:
    'El % de los artículos no se ha añadido a su carrito',
  itemFromYourCartIsUnavailable: '1 artículo de su carrito no está disponible',
  itemsFromYourCartAreUnavailable:
    'El % de los artículos de su carrito no están disponibles',
  itemSuccessfullyDeleted: 'Artículo eliminado correctamente',
  itemSuccessfullyUpdated: 'Artículo actualizado correctamente',
  interchangeSearch: 'Búsqueda de intercambios: %',
  invalidCredentials: 'Credenciales no válidas',
  invalidPart: 'Pieza no válida',
  invoice: 'Factura',
  invoiceDate: 'Fecha de la factura',
  itemNotFoundInOurDatabase:
    'El artículo no se ha encontrado en nuestra base de datos',
  oneItemNotFoundInOurDatabase:
    '1 artículo no se ha encontrado en nuestra base de datos',
  itemFoundWithDuplicatePartNumbersFromDifferentManufacturers:
    'Artículo encontrado con un número de pieza duplicado de diferentes fabricantes',
  oneItemFoundWithDuplicatePartNumbersFromDifferentManufacturers:
    '1 artículo se ha encontrado con un número de pieza duplicado de diferentes fabricantes',
  itemInYourCartWillBeOrderedFromNonPrimaryLocation:
    '1 artículo de su carrito se pedirá desde una ubicación no principal',
  itemsAddedToGroupMsg: '% de artículos añadidos en % de grupos',
  itemsNotFoundInOurDatabase:
    '% de artículos no se han encontrado en nuestra base de datos',
  itemsFoundWithDuplicatePartNumbersFromDifferentManufacturers:
    '% de artículos se han encontrado con números de pieza duplicados de diferentes fabricantes',
  itemsInYourCartWillBeOrderedFromNonPrimaryLocation:
    '% de artículos de su carrito se pedirá desde una ubicación no principal',
  laborRateUpdatedSuccessfully:
    'Tarifa de mano de obra actualizada correctamente',
  tackNo: 'Tack No',
  tapAndRollOverImageToMagnify:
    'Toque y pase el cursor sobre la imagen para ampliarla',
  TotalCostInHours: 'Costo total en horas',
  totalCount: 'Recuento total',
  listImportTimeOutMsg:
    'El servidor no respondió a tiempo. Vuelva a intentarlo dentro de unos momentos.',
  locationType: 'Tipo de ubicación',
  locationSecNo: 'No. de Ubicación Secundaria',
  manufacturerDetails: 'Detalles del fabricante',
  mfrValidationMessage:
    'El código de línea no debe tener menos del % ni más del % de caracteres.',
  moreDetails: 'Más detalles',
  moreThanOneItemWasFoundWithMatchingPartNumbersFromDifferentManufacturers:
    'Se ha encontrado más de un artículo con números de pieza coincidentes de diferentes fabricantes',
  noServiceInterval: 'Intervalo de servicio no disponible',
  notAddedDueToInsufficientQuantity:
    'No se ha añadido debido a una cantidad insuficiente',
  notPrimaryLocation: 'No es la ubicación principal',
  openImageInNewTab: 'Abrir imagen en una nueva pestaña',
  orderSequence: 'Secuencia del pedido',
  organizationSelection: 'Selección de organización',
  orgID: 'ID de la organización',
  origin: 'Origen',
  parts: 'Piezas',
  partIsAlreadyInCartFor: 'La pieza ya está en el carrito para',
  partIsNotVaildText:
    'No hemos podido encontrar un número de pieza válido que coincida con %',
  partIsNotVaildSubText:
    'Compruebe que el número de pieza es correcto o intente otra búsqueda',
  partNumberIsEmpty: `El número de pieza está vacío`,
  plateNumber: 'Número de matrícula.',
  pleaseAddAVehicleToEnsureFitment:
    'Por favor añada un vehículo para garantizar la compatibilidad.',
  pleaseCheckYourFileToEnsureItMeetsTheRequirementsListedAbove:
    'Compruebe su archivo para asegurarse de que cumple los requisitos indicados anteriormente.',
  pleaseSelectTheItemsYouWishToInclude:
    'Por favor seleccione los artículos que desea incluir.',
  poID: 'ID P0',
  goToProductPageToSelectAnotherLocation:
    'Vaya a la página del producto para seleccionar otra ubicación.',
  purchaseOrderNumber: 'Número de orden de compra',
  requestSummary: 'Resumen de la solicitud',
  required: 'Obligatorio',
  returnSummary: 'Resumen de devoluciones',
  released: 'Liberado el',
  releasedBy: 'Liberado por',
  recommendedServicesBody:
    'Seleccione un tipo de intervalo de servicio y un kilometraje para ver los servicios recomendados.',
  renameGroup: 'Renombrar grupo',
  review: 'Revisar',
  reviewItem: `Revisar artículo`,
  reviewItems: 'Revisar artículos',
  rollOverImageToZoom: 'Pase el cursor por la imagen para ampliarla.',
  searchByTabOrder: `«Buscar por» Orden de pestaña`,
  searchTermShouldBeMinimum2Characters:
    'El término de búsqueda debe tener un mínimo de 2 caracteres',
  searchTermShouldBeMinimum3Characters:
    'El término de búsqueda debe tener un mínimo de 3 caracteres.',
  selectAllXItemsInGroup: 'Seleccionar todos los artículos % del grupo',
  selectAllParts: 'Seleccionar todas las piezas',
  selectDescription: 'Seleccionar descripción',
  selectPartsToReturn: 'Seleccionar piezas para devolver',
  selectXItemsOnPage: 'Seleccionar artículos % de la página',
  selectYourItems: 'Seleccionar artículos',
  seller: 'Vendedor',
  sellFromID: 'ID del vendedor',
  sellFromName: 'Nombre del vendedor',
  sellToID: 'ID del comprador',
  sellToName: 'Nombre del comprador',
  shipFromAddress: 'Dirección de envío',
  shipFromID: 'ID de envío',
  shipFromName: 'Nombre de envío',
  shipInstructions: 'Instrucciones de envío',
  shipToAddress: 'Dirección de envío',
  shipToName: 'Nombre de envío',
  startNewOrder: '¿Iniciar nuevo pedido?',
  stockQty: 'Cantidad en Existencias',
  temporarilyUnavailable: 'Temporalmente no disponible',
  theFileShouldIncludeColumnsWithHeadingsForGroupMFRPartNumberStockingQtyandComments:
    'El archivo debe incluir columnas con los encabezados Grupo, Fabricante, Número de pieza, Cantidad en existencia y Comentarios.',
  thePageYourRequestedCouldNotBeFound:
    'No se ha encontrado la página solicitada.',
  editThisItemToAddItToYourCart:
    'Edite este artículo para añadirlo a su carrito.',
  theQuoteWasSavedSuccessfully: 'El presupuesto se ha guardado correctamente.',
  theSelectedPartsWillAppearHear: 'Las piezas seleccionadas aparecerán aquí.',
  thisItemWasNotFoundInOurDatabase:
    'Este artículo no se ha encontrado en nuestra base de datos.',
  thisMayTakeAMoment: 'Esto puede tardar un momento.',
  thisWeek: 'Esta semana',
  totalCore: 'Total núcleo',
  totalLabor: 'Total mano de obra',
  totals: 'Totales',
  totalTransport: 'Total transporte',
  tracking: 'Seguimiento',
  transID: 'ID de seguimiento',
  uid: 'UID',
  unavailableAt: 'No disponible en %',
  unknown: 'Desconocido',
  unknownItem: 'Artículo desconocido',
  uploadFailed: 'Error al cargar',
  useOurTemplateListFile: 'Utilice nuestro archivo de plantilla.',
  userDetails: 'Detalles del usuario',
  userID: 'ID de usuario',
  validate: 'Validar',
  validateItems: 'Validar artículos',
  validatingItems: 'Validando artículos',
  vehicleName: 'Nombre del vehículo',
  verifiedPart: 'Pieza verificada',
  warning: 'Advertencia',
  wasSuccessfullyUpdate: '(%) se actualizó correctamente.',
  weWereUnableToFindThisItemInOurDatabase:
    'No hemos podido encontrar este artículo en nuestra base de datos.',
  willBeOrderFromANonPrimaryLocation:
    'Se pedirá desde %, una ubicación no principal.',
  itemAddedFromMultipleLocationsTooltipDisclaimer:
    'Item added from multiple locations. Select More Locations to update quantity.', // TODO
  'Auto/Light-Medium Truck': 'Auto/Camion Ligero-Mediano',
  'Medium-Heavy Duty Truck': 'Camion de carga mediana-pesada',
  Motorcycle: 'Motocicleta',
  'ATV/UTV': 'ATV/UTV',
  Scooter: 'Scooter',
  Snowmobile: 'Moto de nieve',
  Watercraft: 'Embarcacion',
  Primary: 'Primario',
  Secondary: 'Secundario',
  'All Lines': 'Todas las Líneas',
  undo: 'Deshacer',
  finish: 'Finalizar',
  yes: 'Sí',
  no: 'No',
  selectACategory: 'Selecciona una Categoría',
  selectAList: 'Selecciona una Lista',
  selectAGroup: 'Selecciona un Grupo',
  successfullyPartsHaveBeenMoved: 'Las piezas se han movido correctamente',
  successfullyDeletedPart: 'Parte eliminada con éxito',
  selectMileage: 'Seleccionar Kilometraje',
  noOptions: 'Sin opciones',
  selectPlaceholder: 'Seleccionar...',
  miscellaneousText: 'Misceláneos',
  itemAddedToListMessage: '% fue añadido a la lista: %',
  itemAddedToList: '% fue añadido a la lista',
  itsTakingLongerThanUsualToPerformYourInquiry:
    'Su consulta está tardando más de lo habitual. Por favor espere...',
  yourOrderIsBeingProcessedLeavingMayResultInDuplicateOrders:
    'Su pedido se está procesando. Si sale ahora, puede resultar en pedidos duplicados.',
  itsTakingLongerThanUsualToProcessYourOrder:
    'El procesamiento de su pedido está tardando más de lo habitual.',
  pleaseTryAgainAndContactYourPartsSupplier:
    'Por favor, inténtelo de nuevo y contacte a su proveedor de repuestos si el problema persiste.',
  youCanAlsoCloseThisAndReturnLater:
    'También puedes cerrar esto y volver más tarde; tu carrito seguirá aquí.',
  expand: 'Expandir',
  searchByManufacturerPartNumber: 'Buscar por fabricante, número de pieza',
  selectOrderType: 'Seleccionar tipo de pedido',
  selectTransportType: 'Seleccionar tipo de transporte',
  showNewerYears: 'Mostrar años más recientes',
  showEarlierYears: 'Mostrar años anteriores',
  appliedFilters: 'Filtros aplicados',
  resultsViewSettings: 'Configuración de vista de resultados',
  moreResultActions: 'Más acciones de resultados',
  filterAndSortResults: 'Filtrar y ordenar resultados',
  areYouSureYouWantToProceed: '¿Está seguro de que desea continuar?',
  applyResultFilter: 'Aplicar filtro de resultados',
  imageLoadError: 'Hubo un problema al cargar su imagen',
  companyLogo: 'Logotipo de MyPlace4Parts',
  crossReferenceIcon: 'Icono de referencia cruzada',
  shippedStatus: 'Enviado',
  deliveredStatus: 'Entregado',
  orderedWithCount: 'Pedido (%)',
  packedWithCount: 'Empacado (%)',
  shippedWithCount: 'Enviado (%)',
  deliveredWithCount: 'Entregado (%)',
  itemUnit: 'artículo',
  itemsUnit: 'artículos',
  driver: 'Conductor',
  switchLookup: 'Cambiar búsqueda',
  remove: 'Eliminar',
  proceedWithOrder: 'Proceder con el pedido',
  orderExceptionsMessage: 'Excepciones de pedido',
  orderExceptionsSubMessage:
    'Uno o más artículos necesitan atención, revise antes de realizar su pedido.',
  displayExclTax: 'Sin Impuestos',
}
